<template>
  <transition
  enter-active-class="animate__animated animate__fadeIn animate__slideInUp animate__faster"
  leave-active-class="animate__animated animate__fadeOut animate__slideOutDown animate__faster"
  >
    <div class="new-version-panel" v-if="showPanel">
      <div class="timing-flow">
        <div class="message">
          <p><b>{{$t('version-updater.new-version-available')}}</b></p>
          <p>{{$t('version-updater.update-at')}}</p>
        </div>
        <div class="wrapp-time">
          <div class="time-val">
            <span class="val">{{minutes}}</span>
            <span class="label">{{$t('version-updater.minutes')}}</span>
          </div>
          <div class="separator">:</div>
          <div class="time-val">
            <span class="val">{{seconds}}</span>
            <span class="label">{{$t('version-updater.seconds')}}</span>
          </div>
        </div>
      </div>
      <div class="force-update">
        <button class="btn btn-primary" @click.prevent="reloadPage">{{$t('version-updater.update-now')}}</button>
      </div>
    </div>
  </transition>
</template>

<script>
import { EventBus } from '@/helpers'
import dayjs from 'dayjs'

export default {
  name: 'VersionUpdater',
  data () {
    return {
      showPanel: false,
      countDown: 0
    }
  },
  computed: {
    minutes () {
      return Math.floor((this.countDown % (1000 * 60 * 60)) / (1000 * 60))
    },
    seconds () {
      return Math.floor((this.countDown % (1000 * 60)) / 1000)
    }
  },
  methods: {
    reloadPage () {
      window.location.reload()
    },
    startCountDown () {
      let start = dayjs().add(5, 'minutes').unix() * 1000
      let x = setInterval(() => {
        let now = dayjs().unix() * 1000
        let counter = start - now
        this.countDown = counter
        if (counter <= 0) {
          clearInterval(x)
          this.reloadPage()
        }
      }, 1000)
    },
    managePanel () {
      this.showPanel = true
      this.startCountDown()
    }
  },
  mounted () {
    EventBus.$once('app::new-version-available', this.managePanel)
  },
  destroyed () {
    EventBus.$off('app::new-version-available', this.managePanel)
  }
}
</script>
